import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, Box, Flex, VStack, HStack } from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import { OpenInNewOutlined } from '@mui/icons-material';
import slackIcon from './integration_logos/slack.svg'
import gmailIcon from './integration_logos/gmail.svg'
import outlookIcon from './integration_logos/outlook.svg'
import teamsIcon from './integration_logos/microsoft-teams.svg'
import salesforceIcon from './integration_logos/salesforce.svg'
import hubspotIcon from './integration_logos/hubspot.svg'
import dropboxIcon from './integration_logos/dropbox.svg'
import onedriveIcon from './integration_logos/onedrive.svg'
import sharepointIcon from './integration_logos/sharepoint.svg'
import gdriveIcon from './integration_logos/google-drive.svg'
import seismicIcon from './integration_logos/seismic.png'
import doceboIcon from './integration_logos/docebo.png'
import mindtickleIcon from './integration_logos/mindtickle.png'

// function Integrations() {
//   const navigate = useNavigate();

//   const handleNavigate = (path) => {
//     navigate(path);
//   };

//   return (
//     <Box p={6} overflowY={"auto"} height={"100vh"}>
//       {/* Main Content */}
//       <Text fontSize="2xl" fontWeight="bold" mb={4}>
//         Integrations
//       </Text>

//       <Box overflowY={"auto"} maxH={`calc(100% - 128px)`} data-scrollable="true">
//         <Flex wrap="wrap" gap={10} maxW="100%" p={4}>
//             <Text fontSize="xl" fontWeight="bold" w={"100%"} >
//                 Communications
//             </Text>
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={slackIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Slack
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>
        
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={gmailIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Google Mail
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>


//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={teamsIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Microsoft Teams
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={outlookIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Outlook
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>
//         </Flex>

//         <Flex wrap="wrap" gap={10} maxW="100%" p={4}>
//             <Text fontSize="xl" fontWeight="bold" w={"100%"} >
//                 Sales Enablement
//             </Text>
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={mindtickleIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Mind Tickle
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>
        
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={doceboIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Docebo
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={seismicIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Seismic
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//         </Flex>

//         <Flex wrap="wrap" gap={10} maxW="100%" p={4}>
//             <Text fontSize="xl" fontWeight="bold" w={"100%"} >
//                 CRM
//             </Text>
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={hubspotIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Hub Spot
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={salesforceIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 SalesForce
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//         </Flex>

//         <Flex wrap="wrap" gap={10} maxW="100%" p={4}>
//             <Text fontSize="xl" fontWeight="bold" w={"100%"} >
//                 Document Management
//             </Text>
//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={onedriveIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 One Drive
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={dropboxIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                 Drop Box
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={gdriveIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                     Google Drive
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>

//             <Flex
//             className="account-card"
//             alignItems={'flex-start'}
//             gap={2}
//             p={4}
//             border="1px solid blue.500"
//             shadow="xs"
//             borderRadius="md"
//             cursor={'pointer'}
//             width={'max-content'}
//             height={'max-content'}
//             minW={"28%"}
//             >
//             {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
//             <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
//                 <img src={sharepointIcon} height="28px"></img>
//             </IconButton>
//             {/* <img src={slackIcon} height="28px"></img> */}
//             <Flex flexDir={'column'}>
//                 <Text fontSize="xl" mb={1} color={'#1d1d1d'} mt={1}>
//                     Sharepoint
//                 </Text>
//                 <Text>
//                     Link your account
//                     <IconButton> <OpenInNewOutlined/> </IconButton>
//                 </Text>
//             </Flex>
//             </Flex>
//         </Flex>
//       </Box>




//       {/* Profile Badge */}
//       {/* <div className="profile-badge">
//         <span className="profile-initials">BV</span>
//       </div> */}
//     </Box>
//   );
// }

function Integrations () {
    return (
        <Box paddingLeft={"24px"} backgroundColor={"#F6FAFF"} width={"100%"} maxW={"100%"} maxH={"100%"}>
            <Box
                borderTopLeftRadius={"24px"}
                borderBottomLeftRadius={"24px"}
                backgroundColor={"white"}
                width={"100%"}
                maxW={"100%"}
                height={"100%"}
                height="calc(100vh - 61px)"
                paddingTop={"25px"}
                paddingLeft={"24px"}
                paddingRight={"8px"}
            >
                <VStack align={"start"} flex={4} gap={0} maxWidth={"100%"} maxH={"100%"} overflowY={"scroll"} data-scrollable="true">
                    <Box h={"32px"}>
                        <Text fontFamily={"sans-serif"} color={"#000000"} fontSize={"24px"} fontWeight={"600"}>
                            Integrations
                        </Text>
                    </Box>
                    <Communications />
                    <SalesEnablement />
                    <CRM />
                    <DocumentManagement />
                    <WhiteSpace />
                </VStack>
            </Box>
        </Box>
    )
}

const Communications = () => {
    return (
        <Box
            marginTop={"24px"}
            borderRadius={"8px"}
            border={"1px solid #F4F4F4"}
            w={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 6px rgba(0, 0, 0, 0.12)",
                // borderColor: "#D4D4D4",
            }}
            paddingY={"16px"}
            paddingX={"24px"}
        >
            <Box
                height={"28px"}
                fontSize={"18px"}
                fontWeight={"semibold"}
                fontColor={"#1D1D1D"}
            >
                Communications
            </Box>
            <HStack
                // marginTop={"19px"} 
                overflowX={"scroll"} 
                // overflowY={"hidden"} 
                data-scrollable="true" 
                // gap={"12px"} 
                maxWidth={"100%"} 
                h={"172px"}
                // minH={"195px"}
                marginY={0}
                padding={0}
                marginTop={"16px"}
                gap={"24px"}
            >
                <IntegrationCard 
                    icon={slackIcon}
                    heading={"Slack"}
                />
                <IntegrationCard
                    icon={gmailIcon}
                    heading={"Google Mail"}
                />
                <IntegrationCard
                    icon={teamsIcon}
                    heading={"Microsoft Teams"}
                />
                <IntegrationCard
                    icon={outlookIcon}
                    heading={"Outlook"}
                />
            </HStack>
        </Box>
    )
}

const SalesEnablement = () => {
    return (
        <Box
            marginTop={"24px"}
            borderRadius={"8px"}
            border={"1px solid #F4F4F4"}
            w={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 6px rgba(0, 0, 0, 0.12)",
                // borderColor: "#D4D4D4",
            }}
            paddingY={"16px"}
            paddingX={"24px"}
        >
            <Box
                height={"28px"}
                fontSize={"18px"}
                fontWeight={"semibold"}
                fontColor={"#1D1D1D"}
            >
                Sales Enablement
            </Box>
            <HStack
                // marginTop={"19px"} 
                overflowX={"scroll"} 
                // overflowY={"hidden"} 
                data-scrollable="true" 
                // gap={"12px"} 
                maxWidth={"100%"} 
                h={"172px"}
                // minH={"195px"}
                marginY={0}
                padding={0}
                marginTop={"16px"}
                gap={"24px"}
            >
                <IntegrationCard 
                    icon={mindtickleIcon}
                    heading={"Mind Tickle"}
                />
                <IntegrationCard
                    icon={doceboIcon}
                    heading={"Docebo"}
                />
                <IntegrationCard
                    icon={seismicIcon}
                    heading={"Seismic"}
                />
            </HStack>
        </Box>
    )
}

const CRM = () => {
    return (
        <Box
            marginTop={"24px"}
            borderRadius={"8px"}
            border={"1px solid #F4F4F4"}
            w={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 6px rgba(0, 0, 0, 0.12)",
                // borderColor: "#D4D4D4",
            }}
            paddingY={"16px"}
            paddingX={"24px"}
        >
            <Box
                height={"28px"}
                fontSize={"18px"}
                fontWeight={"semibold"}
                fontColor={"#1D1D1D"}
            >
                Sales Enablement
            </Box>
            <HStack
                // marginTop={"19px"} 
                overflowX={"scroll"} 
                // overflowY={"hidden"} 
                data-scrollable="true" 
                // gap={"12px"} 
                maxWidth={"100%"} 
                h={"172px"}
                // minH={"195px"}
                marginY={0}
                padding={0}
                marginTop={"16px"}
                gap={"24px"}
            >
                <IntegrationCard
                    icon={hubspotIcon}
                    heading={"Hub Spot"}
                />
                <IntegrationCard
                    icon={salesforceIcon}
                    heading={"SalesForce"}
                />
            </HStack>
        </Box>
    )
}

const DocumentManagement = () => {
    return (
        <Box
            marginTop={"24px"}
            borderRadius={"8px"}
            border={"1px solid #F4F4F4"}
            w={"100%"}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
            _hover={{
                // boxshadow: "0px 4px 6px rgba(0, 0, 0, 0.12)",
                // borderColor: "#D4D4D4",
            }}
            paddingY={"16px"}
            paddingX={"24px"}
        >
            <Box
                height={"28px"}
                fontSize={"18px"}
                fontWeight={"semibold"}
                fontColor={"#1D1D1D"}
            >
                Document Management
            </Box>
            <HStack
                // marginTop={"19px"} 
                overflowX={"scroll"} 
                // overflowY={"hidden"} 
                data-scrollable="true" 
                // gap={"12px"} 
                maxWidth={"100%"} 
                h={"172px"}
                // minH={"195px"}
                marginY={0}
                padding={0}
                marginTop={"16px"}
                gap={"24px"}
            >
                <IntegrationCard
                    icon={onedriveIcon}
                    heading={"One Drive"}
                />
                <IntegrationCard
                    icon={dropboxIcon}
                    heading={"Drop Box"}
                />
                <IntegrationCard
                    icon={gdriveIcon}
                    heading={"Google Drive"}
                />
                <IntegrationCard
                    icon={sharepointIcon}
                    heading={"Sharepoint"}
                />
            </HStack>
        </Box>
    )
}

const IntegrationCard = ({ icon, heading }) => {
    return (
        <VStack
            align={"start"} 
            bgColor={"#FAFAFF"} 
            // paddingY={"24px"} 
            // paddingX={"16px"} 
            padding={"16px"}
            gap={"8px"} 
            minWidth={"328px"}
            maxWidth={"328px"}
            border={"1px solid #F4F4F4"}
            borderRadius={"8px"}
            _hover={{ 
                cursor: "pointer",
                backgroundColor: "#F2F2F7",
                // boxshadow: "0px 4px 8px rgba(0, 0, 0, 0.14)",
            }} 
            m={0}
            // boxshadow={"0px 4px 6px rgba(0, 0, 0, 0.08)"}
        >
            <HStack width={"100%"} justifyContent={"flex-start"} alignContent={"center"}>
                <IconButton sx={{ m:1, padding:0, width:"28px", height:"28px", "&:hover": { backgroundColor: "transparent"} }}>
                    <img src={icon} height="28px"></img>
                </IconButton>
                <Text height={"28px"} marginBottom={"4px"} fontFamily={"sans-serif"} color={"#1D1D1D"} fontSize={"20px"} fontWeight={"600"} isTruncated>
                    {heading}
                </Text>
            </HStack>
            <Text fontFamily={"sans-serif"} marginLeft={"16px"} color={"#1D1D1D"} fontSize={"14px"} fontWeight={"400"} h={"42px"} noOfLines={2}>
                Link your account
                <IconButton> <OpenInNewOutlined/> </IconButton>
            </Text>
        </VStack>
    )
}

const WhiteSpace = () => {
    return (
        <Box
            height={"0px"}
            width={"100%"}
            borderRadius={"8px"}
            backgroundColor={"transparent"}
            marginTop={"24px"}
        >
        </Box>
    )
}

export default Integrations;
